/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Valid fields to include when using a Query, all other fields of BioSampleV1 are included. Always included fields are bioSampleId, sampleCode, sampleKitCode, sampleCodeFormat, userId, eventId, audit, scheduleRequestRef.
 */
export enum BioSampleIncludeFieldsV1 {
    CONTAINER_DESCRIPTION = 'CONTAINER_DESCRIPTION',
    CUSTOM_STATUSES = 'CUSTOM_STATUSES',
    PREVIOUS_CUSTOM_STATUSES = 'PREVIOUS_CUSTOM_STATUSES',
    METAS = 'METAS',
    REFS = 'REFS',
}